import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import ProductImages from './product-images';
import ProductDetails from './product-details';
import Breadcrumb from './breadcrumb';
import Wrapper from '../elements/wrapper';
import { media } from '../helpers';

const ProductTopSectionContainer = styled.div`
    padding-top: 30px;
    padding-bottom: 30px;
    position: relative;
    z-index: 10;
    ${media.medium`padding-top: 70px;`}

    .product-top-wrapper {
        ${media.medium`display: flex;`}
    }
`;

const ProductTopSection = ({
    product,
    isCustomizerOpen,
    setIsCustomizerOpen,
    setIsSizeGuideOpen,
}) => {
    const [currentVariant, setCurrentVariant] = useState();
    const [currentProductImages, setCurrentProductImages] = useState([]);
    const [qty, setQty] = useState(1);

    function sortImagesByColor(color) {
        // if it's set to all,
        if (color !== 'all') {
            let newImages = [];

            // based on their current alt tags setup, it will add 2 images after the one with the alt tag
            product.images.map((image, index) => {
                if (image.altText.split('-')[2].trim() === color) {
                    newImages.push(product.images[index]);
                    newImages.push(product.images[index + 1]);
                    newImages.push(product.images[index + 2]);
                }
            });
            // console.log(newImages);
            setCurrentProductImages(newImages);
        } else {
            // if it is, set to all product images
            setCurrentProductImages(product.images);
        }
    }

    function handleVariantChange(variant) {
        setCurrentVariant(variant);

        let newColor;
        variant.selectedOptions.map((option) => {
            if (option.name === 'Color') {
                newColor = option.value;
            }
        });

        if (newColor !== undefined) {
            sortImagesByColor(newColor);
        } else {
            sortImagesByColor('all');
        }
    }

    useEffect(() => {
        // TODO: make first load behavior conditional based on link
        const firstVariant = product.variants[0];
        let firstColor;
        firstVariant.selectedOptions.map((option) => {
            if (option.name === 'Color') {
                firstColor = option.value;
            }
        });
        setCurrentVariant(firstVariant);
        if (firstColor !== undefined) {
            sortImagesByColor(firstColor);
        } else {
            sortImagesByColor('all');
        }
    }, []);

    return (
        <ProductTopSectionContainer>
            {/* breadcrumb */}
            <Breadcrumb product={product} />

            {/* product images / product details */}
            <Wrapper className="product-top-wrapper">
                <ProductImages
                    images={currentProductImages}
                    product={product}
                />
                <ProductDetails
                    handleVariantChange={handleVariantChange}
                    qty={qty}
                    setQty={setQty}
                    currentVariant={currentVariant}
                    product={product}
                    custom={false}
                    isCustomizerOpen={isCustomizerOpen}
                    setIsCustomizerOpen={setIsCustomizerOpen}
                    setIsSizeGuideOpen={setIsSizeGuideOpen}
                />
            </Wrapper>
        </ProductTopSectionContainer>
    );
};

export default ProductTopSection;
